import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

export const TooltipDivider = styled.hr`
    width: 100%;
    border: none;
    border-top: 1px solid ${colorsPalettes.bluegrey[300]}33;
    margin: 0;
`;

export const TooltipHintBox = styled.div`
    display: flex;
    align-items: center;
    padding: 6px 8px;
    border-radius: 4px;
    background: ${colorsPalettes.bluegrey[300]}33;
`;

export const CompactContainer = styled.div`
    height: 36px;
    display: flex;
    align-items: center;
    gap: 16px;
    background: ${colorsPalettes.carbon[0]}99;
    border-radius: 6px;
    padding: 0 16px;
`;

export const CompactItem = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    flex: 1;
`;

export const CompactTrackedItem = styled(CompactItem)`
    flex: none;
    width: 220px;
`;

export const CompactDivider = styled.div`
    width: 1px;
    align-self: stretch;
    background: ${colorsPalettes.carbon[50]};
`;

export const CompactLabel = styled.span`
    display: flex;
    align-items: center;
    gap: 2px;
    flex: 1 0 0;
    ${setFontVariant("input2", colorsPalettes.carbon[300])};
`;

export const CompactValue = styled.span`
    ${setFontVariant("subtitle2", colorsPalettes.carbon[500])};
`;
